module.exports = __webpack_public_path__ + "static/img/18.e5bba8c9.png";